<template>
  <v-container class="main-content pb-10" id="contact" fluid>
    <v-row class="text-center">
      <v-col cols="12" data-aos="fade-right">
        <p class="text-center text-h3 mt-10 white--text">Contact me</p>
        <p class="white--text text-md-h5 text-body-1 text-center">
          Have a question or a proposition? Feel free to get in touch with me.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        class="text-center"
        v-for="i in buttonDetails"
        :key="i.link"
      >
        <v-btn :href="i.link" target="_blank" x-large color="white">
          <span>
            <v-icon left> {{ i.icon }} </v-icon>
            {{ i.title }}
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      buttonDetails: [
        {
          icon: "mdi-send",
          title: "Send an email",
          link: "mailto:a.todorov.it@gmail.com",
        },
        {
          icon: "$githubIcon",
          title: "View Profile",
          link: "https://github.com/BoostedPenguin",
        },
        {
          icon: "$linkedInIcon",
          title: "View Profile",
          link: "https://www.linkedin.com/in/aleksandar-todorov-09b536221/",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.main-content {
  background-color: rgb(44, 44, 44);
}
</style>